import React from "react";
import Divider from "../../../components/Divider";

const IMG_URL = process.env.REACT_APP_IMG_URL;

const BossSectionComponent = ({ patch, sec, index, initialPatch }) => {
  return (
    <div key={index} id={sec?.id}>
      <div className="flex items-center">
        <h4 className="text-xl text-start font-semibold mb-6">
          {initialPatch &&
            index + 1 + ". Bölüm: Boss Güncellemesi - " + sec?.title}
        </h4>
      </div>
      <div className="p-4 md:p-12 text-start break-words border border-gray-600 rounded-md">
        {sec?.thumbnail?.length > 0 ? (
          <div
            key={sec?.id}
            className="w-full grid grid-cols-1 md:grid-cols-[auto_1fr]"
          >
            <img
              className="max-w-48 h-48 mx-auto md:w-auto md:col-span-1 col-span-2"
              src={
                sec?.thumbnail[0]?.includes("uploads")
                  ? IMG_URL + sec.thumbnail
                  : sec.thumbnail
              }
              alt={patch?.title}
            />
            <div className="md:mt-0 mt-10 px-6">
              <h4 className="text-xl text-center md:text-start font-semibold mb-6">
                {sec?.title}
              </h4>
              <div
                className="block"
                style={{ color: "white" }}
                dangerouslySetInnerHTML={{
                  __html: sec.content.replace(/\s+/g, " ").replace(/\n/g, ""),
                }}
              />
            </div>
            <div className="col-span-2 mt-12 break-words">
              <ul className="list-disc ml-8 space-y-4 break-words">
                {sec.table.rows.map((row, idx) => (
                  <li className="space-x-2 break-words" key={idx}>
                    <div  className="sm:flex space-y-2 sm:space-y-0 gap-x-2">
                    <div className="font-bold text-xl break-words">{row[0]}:</div>
                    <div className="flex break-all items-center space-x-2 break-words text-lg">
                      <span>{row[1]}</span>
                      <span className="text-xl">→</span>
                      <span className="font-bold break-words">{row[2]}</span>
                    </div></div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : (
          <div key={sec?.id} className="break-words">
            <div
              className="block"
              style={{ color: "white" }}
              dangerouslySetInnerHTML={{
                __html: sec?.content?.replace(/\s+/g, " ").replace(/\n/g, ""),
              }}
            />
          </div>
        )}

        {sec?.images &&
          sec.images.map((img, index) => (
            <img
              key={index}
              className="mt-24 rounded-2xl"
              src={img?.includes("uploads") ? IMG_URL + img : img}
              alt={patch.title}
            />
          ))}
      </div>
      <Divider />
    </div>
  );
};

export default BossSectionComponent;
